<template>
  <div id="task_QRCode">

    <Modal v-model="QRCodeWindow" title="报名二维码" :styles="{'top':'60px', 'max-height': '400px', 'overflow-y': 'auto'}" :mask-closable="false">
      <table id="qrCodePrint" class="container" cellspacing="0" cellpadding="0" align="center" style="text-align:center;">
        <tbody>
        <tr><td><span style="font-weight: bold;font-size: 18px;">{{edit.name}}</span></td></tr>
        <tr>
          <td><img :src="edit.wxCodeUrl" style="width:180px;height:180px;"/></td>
        </tr>
        <tr><td style="font-size: 18px;">有效期: {{edit.signUpStartDate}} 至 {{edit.signUpEndDate}}</td></tr>
        </tbody>
      </table>
      <div slot="footer">
        <a id="print" v-print="printContent" v-show="false">打印</a>
        <Button @click="QRCodeWindow = false">取消</Button>
        <Button type="primary" @click="print">打印</Button>
<!--        <Button type="primary" @click="download">下载</Button>-->
      </div>
    </Modal>

  </div>
</template>
<script>
import {_getTaskInfoQRCode, _downloadQrCode} from "@/services/task/task";
export default {
  name: "TaskQRCode",
  data() {
    return {
      disabled:false,
      QRCodeWindow:false,
      columns : [

      ],
      edit: {
        id:"",
        name:"",
        schoolName:"",
        signUpStartDate:"",
        signUpEndDate:"",
        wxCodeUrl:"",
      },
      printContent:{
        id:"qrCodePrint",
        preview:false,
        previewTitle:'  ',
        popTitle:'  ',
        extraHead:'<meta http-equiv="Content-Language" content="zh-cn"/>',
        previewBeforeOpenCallback(){

        },
        previewOpenCallback(){

        },
        beforeOpenCallback(vue){
          vue.printLoading=true

        },
        openCallback(vue){
          vue.printLoading=false

        },
        closeCallback(){

        },
        clickMounted(vue){
          vue.printContent.popTitle="      "
        }
      },
      init: "",
      loading: {
        form: false,
        btn: false
      },
      taskElem:[],
      taskRule: {

      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    getTaskInfoQRCode(taskId){
      _getTaskInfoQRCode({taskId:taskId}).then(res=>{
        if (res.errcode === 1 && res.data) {
          this.edit = res.data;
        }
      });
    },
    handleModal(taskId) {
      this.QRCodeWindow = true;
      this.getTaskInfoQRCode(taskId);
    },
    print(){
      this.$nextTick(()=>{
        document.getElementById('print').click();
      })
    },
    download(){
      _downloadQrCode({taskId:this.edit.id}).then(res => {
        if (res && res.errcode && res.errcode === 1){

        } else{
          this.$message.error(res.errmsg)
        }
      })
    }
  }
};
</script>

